export default __webpack_public_path__ + "static/edge-c37fd933e8584de5247ccaf428446e35.png";